<template>
    <div class="item-wrapper border-radius" :style="'margin-left:' + indent + 'px;'">
        <div class="item-details" v-if="isFlat">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path stroke="#DDE2E7" stroke-width="3" fill="none"
                stroke-linecap="round"
                d="M 5 10 h 7"  />
            </svg>
            <div class="item-labels">
                <div class="item-name">
                    {{ itemDetails.fqn_cache }}
                    ({{ itemDetails.id }})
                </div>
                <div class="item-actions" v-if="isSmart && $parent.$parent.permissionAllowed('manage_products')">
                    <button type="button" class="pr-2 btn btn-link btn-category" v-if="isSmart" @click.stop="editRule">Edit Rule</button>
                    <i class="pr-4 fa fa-lightbulb-o smart-icon" aria-hidden="true"></i>
                </div>
                <div class="item-actions" v-else>
                    <div v-if="$parent.$parent.permissionAllowed('manage_products')">
                        <button type="button" class="btn btn-link btn-category remove-action" v-if="isAssigned" @click.stop="remove">Remove</button>
                        <button type="button" class="btn btn-link btn-category " v-else @click.stop="add">Add</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="item-details" :class="{'is-clickable': isClickable }" @click="toggleChildShow" v-else>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-if="itemDetails.has_children">
                <path v-if="!showChildren" stroke="#3F759E" stroke-width="3" fill="none"
                stroke-linecap="round"
                d="M 5 5 l 5 5 l -5 5"  />
                <path v-else stroke="#3F759E" stroke-width="3" fill="none"
                stroke-linecap="round"
                d="M 2 8 l 5 5 l 5 -5"  />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" v-else>
                <circle cx="7" cy="10" r="5" fill="#DDE2E7"/>
            </svg>
            <div class="item-labels">
                <div class="item-name">
                    {{ itemDetails.name }}
                </div>
                <div class="item-actions" v-if="isSmart">
                    <button type="button" class="pr-2 btn btn-link btn-category" v-if="isSmart" @click.stop="editRule">Edit Rule</button>
                    <i class="pr-4 fa fa-lightbulb-o smart-icon" aria-hidden="true"></i>
                </div>
                <div class="item-actions" v-else>
                    <button type="button" class="btn btn-link btn-category remove-action" v-if="isAssigned" @click.stop="remove">Remove</button>
                    <button type="button" class="btn btn-link btn-category"  v-else @click.stop="add">Add</button>
                </div>
            </div>
        </div>
        <div class="category-child-list" v-if="showChildren && !isFlat">
                <category-item v-for="(item, idx) in categoryChildren" :key="idx"
                    :itemDetails="item"
                    :allItems="allItems"
                    :all-assignments="allAssignments"
                    :depth="depth + 1"
                    v-on="$listeners">
                </category-item>
                <div v-if="categoryChildren.length == 0" class="p-3 text-center">
                    <span class="fa fa-cog fa-spin fa-1x"></span>
                </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

let base_url = window.location.protocol + "//" + window.location.host

export default {
    name: 'category-item',
    props: {
        itemDetails: Object,
        allItems: Array,
        allAssignments: Array,
        depth: Number,
        isFlat: Boolean,
    },
    computed: {
        indent() {
            return this.depth * 10;
        },
        isSmart() {
            return (this.itemDetails.is_smart == 1);
        },
        isClickable() {
            return (this.itemDetails.has_children);
        },
        isAssigned() {
            let assigned = false;
            this.allAssignments.forEach(element => {
                if (element.id == this.itemDetails.id) {
                    assigned = true;
                }
            });

            return assigned;
        },
    },
    data() {
        return {
            showChildren: false,
            hasLoadedChildren: false,
            categoryChildren: [],
        }
    },
    methods: {
        add() {
            this.$emit('add', this.itemDetails.id);
        },
        remove() {
            this.$emit('remove', this.itemDetails.id);
        },
        editRule() {
            location.href = "/categories/"+ this.itemDetails.id +"/edit?tab=rules";
        },
        toggleChildShow() {
            if (this.isClickable) {
                this.showChildren = !this.showChildren;
            }
            if (this.hasLoadedChildren === false) {
                axios.get(base_url+ '/pimapi/categories/' + this.itemDetails.id + '/children')
                .then((response) => {
                    this.hasLoadedChildren = true;
                    this.categoryChildren = response.data;
                })
                .catch((error) => {
                });
            }
        },
    }
}
</script>

<style lang="scss">

.is-clickable {
    cursor: pointer;
}

.item-labels {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.item-details {
    display: flex;
    align-items: center;
    background-color: white;
    margin: 0 0 5px 0;
    border-color: #DEE0E1;
    border-style: solid;
    border-radius: 5px;
    border-width: 1px;
    height: 35px;
    padding: 0 5px;
}

.btn-category {
    color: #3F759E;

    &.remove-action {
        color: #AB5755;
    }
}

.item-actions {
    display: flex;
    align-items: center;
}

.smart-icon {
    color: #3F759E;
}

</style>
